import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "ds-focus-ring inline-flex items-center rounded-full px-3 py-1 text-xs font-bold tracking-wide transition-colors",
  {
    variants: {
      variant: {
        default:
          "border border-transparent bg-primary text-primary-foreground shadow-sm shadow-primary/20",
        secondary:
          "ds-badge hover:bg-card/90",
        destructive:
          "border border-transparent bg-destructive text-destructive-foreground shadow-sm",
        outline: "ds-badge bg-transparent",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }